import copyToClipboard from "copy-to-clipboard";

// copy-to-clipboard が mock とか spyOn しづらいからラップする
// module.exports = copy とかどう mock すればいいのプンってなった
export const copy = copyToClipboard;
